import styles from './PersonalityRadarChart.module.css';

const PersonalityRadarChart = ({ personalityData }) => {
  if (!personalityData) return null;

  const traits = {
    O: { name: 'Openness', value: personalityData.opennessScore || 50 },
    C: {
      name: 'Conscientiousness',
      value: personalityData.conscientiousnessScore || 50,
    },
    E: { name: 'Extraversion', value: personalityData.extraversionScore || 50 },
    A: {
      name: 'Agreeableness',
      value: personalityData.agreeablenessScore || 50,
    },
    N: { name: 'Neuroticism', value: personalityData.neuroticismScore || 50 },
  };

  const traitLabels = Object.keys(traits);
  const points = Object.values(traits).map((t) => t.value);
  const angleSlice = (Math.PI * 2) / 5;

  const getPoint = (value, index, offset = 0) => {
    const angle = angleSlice * index - Math.PI / 2;
    const radius = (value / 100) * (45 - offset);
    const x = 50 + radius * Math.cos(angle);
    const y = 50 + radius * Math.sin(angle);
    return { x, y };
  };

  const dataPoints = points
    .map((p, i) => {
      const point = getPoint(p, i);
      return `${point.x},${point.y}`;
    })
    .join(' ');

  const axisPoints = Array(5)
    .fill(100)
    .map((p, i) => {
      const point = getPoint(p, i);
      return `${point.x},${point.y}`;
    })
    .join(' ');

  return (
    <div className={styles.radarContainer}>
      <svg viewBox="-15 -15 130 130" className={styles.radarSvg}>
        <polygon className={styles.radarGrid} points={axisPoints} />
        <polygon
          className={styles.radarGridInner}
          points={Array(5)
            .fill(66)
            .map((p, i) => {
              const point = getPoint(p, i);
              return `${point.x},${point.y}`;
            })
            .join(' ')}
        />
        <polygon
          className={styles.radarGridInner}
          points={Array(5)
            .fill(33)
            .map((p, i) => {
              const point = getPoint(p, i);
              return `${point.x},${point.y}`;
            })
            .join(' ')}
        />

        {traitLabels.map((label, i) => {
          const point = getPoint(100, i, -8);
          return (
            <text
              key={label}
              x={point.x}
              y={point.y}
              className={styles.radarAxisLabel}
              textAnchor="middle"
              dominantBaseline="middle"
            >
              {label}
            </text>
          );
        })}
        <polygon className={styles.radarData} points={dataPoints} />
      </svg>

      <ul className={styles.radarLegend}>
        {Object.entries(traits).map(([key, trait]) => (
          <li key={key}>
            <span className={styles.legendKey}>{key}</span>
            <span className={styles.legendName}>{trait.name}</span>
            <span className={styles.legendValue}>{trait.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PersonalityRadarChart;
